<div class="ot-row">
  <h1 class="ot-wizard-title ot-m-1" style="font-weight: 400" i18n>Collect log packages</h1>
</div>
<app-wizard [index]="index" [steps]="steps"></app-wizard>
<!-- states -->
@switch (state) {
@case (LogPackageState.SC_LOGS) {
<div class="ot-pt-1" style="height: calc(100vh - 295px);">
  <ng-scrollbar #scrollbarRef>
    <form [formGroup]="packageForm" name="package-name-form">
      <fieldset [disabled]="started">
        <div class="ot-row">
          <div class="ot-col ot-row__column ot-row__column--is-33">
            <div class="ot-form-control ot-pl-1"
              [ngClass]="{'ot-form-control--is-invalid' : (packageNameCtrl.touched && packageNameCtrl.invalid)}">
              <label class="ot-form-control__label" for="package-name">
                <span class="ot-form-control--is-required" style="padding-right: 5px;">*</span>
                <span i18n>Package name</span>
              </label>
              <div class="ot-form-control__input-group">
                <input id="package-name" formControlName="packageNameCtrl" placeholder="Enter a package name"
                  type="text" maxlength="100" class="ot-input ot-input--is-expanded">
                @if (packageNameCtrl.touched && packageNameCtrl.invalid) {
                <span class="ot-form-control__error-icon"></span>
                }
              </div>
              @if (packageNameCtrl.touched && packageNameCtrl.invalid && packageNameCtrl.errors.required) {
              <p id="packageNameRequiredMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                Package name is required.
              </p>
              }
              @if (packageNameCtrl.errors?.pattern && packageNameCtrl.dirty) {
              <p id="packageNameCharacterMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                Invalid characters.
              </p>
              }
            </div>
          </div>
        </div>
        <div class="ot-row">
          <div class="ot-col ot-row__column">
            <div class="ot-form-control ot-pl-1 ot-mb-0">
              <label for="notificationPurgeList" class="ot-form-control__label ot-form-control__label--for-group"
                i18n>System Center log options</label>
              <div class="ot-checkbox-group">
                <div class="ot-checkbox-options ot-grid--is-4-columns">
                  <app-checkbox [identifier]="'includeMgrLogs'" formControlName="includeMgrLogsCtrl"
                    [name]="'includeMgrLogs'" [toggle]="false" i18n-label [label]="'Manager logs'" i18n-arialabel
                    [arialabel]="'Manager logs'" i18n-description
                    [description]="'This option will include the System Center Manager logs.'">
                  </app-checkbox>
                  <app-checkbox [identifier]="'includeSysReport'" formControlName="includeSysReportCtrl"
                    [name]="'includeSysReport'" [toggle]="false" i18n-label [label]="'System Center system report'"
                    i18n-arialabel [arialabel]="'System Center system report'" i18n-description
                    [description]="'This option will include a detailed report of this System Center installation.'">
                  </app-checkbox>
                  <app-checkbox [identifier]="'includeLandscape'" formControlName="includeLandscapeCtrl"
                    [name]="'includeLandscape'" [toggle]="false" i18n-label [label]="'Product landscape files'"
                    i18n-arialabel [arialabel]="'Product landscape files'" i18n-description
                    [description]="'This option will include the product landscape files from an agent.'">
                  </app-checkbox>
                  <app-checkbox [identifier]="'includeAgentLogs'" formControlName="includeAgentLogsCtrl"
                    [name]="'includeAgentLogs'" [toggle]="false" i18n-label [label]="'Agent logs'" i18n-arialabel
                    [arialabel]="'Agent logs'" i18n-description
                    [description]="'This option will include the System Center Agent logs.'">
                  </app-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
    <div style="height: 350px;">
      <app-datatable [identifier]="'log-agents-table'" [title]="agentTitle" [cols]="agentCols" [rows]="agentRows"
        [isloading]="agentsLoading" [showcheckboxes]="true" (checkboxchangeevent)="selectAgent($event)"
        (selectAllClickEvent)="selectAgent($event)" [scroll]="true"
        [overrideSelectAll]="overrideAgentSelectAll"></app-datatable>
    </div>
  </ng-scrollbar>
</div>
}
@case (LogPackageState.PROD_LOGS) {
@if(this.selectedEnvironment){
<div class="ot-message"
  [ngClass]="{'ot-message--is-info': hasSufficientDiskSpace, 'ot-message--is-error': !hasSufficientDiskSpace}">
  <div class="ot-message__banner">
    <p class="ot-pl-1" id="logs-package-prod-logs-info-msg" i18n [innerHTML]="productLogsMsg"></p>
  </div>
</div>
<div style="height: calc(100vh - 358px);">
  <app-datatable [scroll]="true" [identifier]="'prod-logs-pkg-table'" [title]="''" [cols]="productLogsPkgCols"
    [rows]="productLogsPkgRows" [isloading]="loadingProdLogsPkg" [showcheckboxes]="true" [total]="totalProductLogsPkg"
    (actionmenuevent)="actionMenuClicked($event)" [isSortable]="false"
    (checkboxchangeevent)="selectSingleProdLog($event)"
    (selectAllClickEvent)="selectAllProdLogs($event)"></app-datatable>
</div>
}@else{
<div class="ot-progress-container ot-pt-3" style="height: calc(100vh - 297px);">
  <div id="ot-spinner-text" class="ot-progress ot-progress--is-spinner ot-progress--is-spinner-has-text">
    <div class="ot-progress__outer">
      <div class="ot-progress__meter">
      </div>
    </div>
    <div class="ot-progress__text" i18n>Loading...</div>
  </div>
</div>
}
}
@case (LogPackageState.SUPPORT_CASE_INFO) {
@if(isSupportCaseStateReady || loadingDirectories){
<div
  [ngClass]="{'ot-message--is-info': isAuthenticated && !isUploaded, 'ot-message--is-warning': !isAuthenticated, 'ot-message--is-success': isAuthenticated && isUploaded}"
  class="ot-message">
  <div class="ot-message__banner">
    <p class="ot-pl-1" id="logs-package-upload-msg">
      {{supportCaseInfoText}}
    </p>
  </div>
</div>
<div class="ot-sftp-container">
  <div class="ot-sftp-body">
    <div class="ot-sftp-side-panel" [resizable]="ftpDir?.length > 0">
      @if(isAuthenticated && !isUploaded){
      <div class="ot-sftp-side-panel-title ot--is-inline-flex" [attr.title]="this.ftpSidePanelTitle">
        <div class="ot-sftp-side-panel-title-text">
          <span>{{ftpSidePanelTitle}}</span>
        </div>
        <div style="padding:0.5rem">
          <button data-name="refresh-tree-button" i18n-title title="Refresh directories" aria-label="trigger"
            (click)="refreshSFTPTree()" role="button" class="ot-sftp-refresh-icon">
          </button>
        </div>
      </div>
      }
      <div id="ot-sftp-side-panel-container" style="border-bottom: none;">
        <app-tree [noItemsMsg]="ftpDirEmptyMsg" [scroll]="true" [adjustForSidePanelTitle]="false" [data]="ftpDir"
          [scrollHeight]="'height: calc(100vh - 405px);'" (expandevent)="expandTree($event)"
          (changeevent)="changeTree($event)"></app-tree>
      </div>
    </div>
    <div class="ot-sftp-table-panel">
      <app-datatable [identifier]="'sftp-files-table'" [title]="ftpFileTableTitle" [titleIcon]="ftpFileTableTitleIcon"
        [cols]="ftpFileTableCols" [rows]="ftpFileTableRows" [isloading]="ftpLoading" [showcheckboxes]="false"
        [pagination]="false" [isSortable]="false" [scroll]="true" style="width:100%"></app-datatable>
    </div>
  </div>
</div>
}@else {
<div class="ot-progress-container ot-pt-3" style="height: calc(100vh - 297px);">
  <div id="ot-spinner-text" class="ot-progress ot-progress--is-spinner ot-progress--is-spinner-has-text">
    <div class="ot-progress__outer">
      <div class="ot-progress__meter">
      </div>
    </div>
    <div class="ot-progress__text" i18n>Loading...</div>
  </div>
</div>
}
}
}
<div class="ot-wizard-panel-footer ot-wizard-panel-footer--is-right-justified" style="border-top: 1px solid #dce4e8;"
  [ngClass]="{'ot-flex--is-space-between' : index > 0, 'ot-wizard-panel-footer--is-right-justified' : index == 0 || steps.length - 1 == index}">
  @if (index > 0 && index < steps.length - 1) { <button [id]="prevButtonId" [disabled]="" role="button" (click)="back()"
    aria-label="Back" i18n-title title="Back"
    class="otsc-btn__back ot-btn ot-btn--is-micro ot-btn--is-icon-btn ot-ml-1">
    <div class="otsc-back_btn">
    </div>
    </button>
    }
    <div class="ot-btn-group">
      @switch (state) {
      @case (LogPackageState.PROD_LOGS) {
      <button id="prolog-next-button" [disabled]="loadingProdLogsPkg || !hasSufficientDiskSpace" role="button"
        otsc-button color="primary" (click)="next()" i18n>Next</button>
      }
      @case (LogPackageState.SC_LOGS) {
      <button id="sclog-next-button" [disabled]="packageForm.invalid || started" role="button" otsc-button
        color="primary" (click)="next()" i18n>Next</button>
      }
      @case (LogPackageState.SUPPORT_CASE_INFO) {
      @if(isAuthenticated){
      @if(isUploaded){
      <button id="sftp-close-button" role="button" otsc-button color="primary" (click)="complete()" i18n>Close</button>
      }
      @else {
      <button id="sftp-upload-button" role="button" [disabled]="ftpLoading || selectedFTPDir == undefined" otsc-button
        color="primary" (click)="next()" i18n>Upload</button>
      }
      }
      @else{
      <button id="sftp-signin-button" role="button" otsc-button color="primary" (click)="signIn()" i18n>Sign in to
        upload</button>
      }
      }
      }
      @if(!isUploaded){
      <button id="logspkg-cancel-button" [disabled]="loadingDirectories" role="button" otsc-button color="secondary"
        (click)="cancel()" i18n>Cancel</button>
      }
    </div>
</div>